import { render, staticRenderFns } from "./Yuyue.vue?vue&type=template&id=633e4f44&scoped=true"
import script from "./Yuyue.vue?vue&type=script&lang=js"
export * from "./Yuyue.vue?vue&type=script&lang=js"
import style0 from "./Yuyue.vue?vue&type=style&index=0&id=633e4f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633e4f44",
  null
  
)

export default component.exports